'use es6';

import http from 'hub-http/clients/apiClient';
/**
 * GET sfdc/v1/connection-status
 */

export function fetch() {
  return http.get('sfdc/v1/connection-status');
}